/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import StockIt from './user-performances/stock-it';
import PriceIt from './user-performances/price-it';
import SellIt from './user-performances/sell-it';
import PriceItPlus from './user-performances/price-it-plus';

class UserPerformancesList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  dateConvert = (dateString) => {
    const date = new Date(dateString);
    const parsed = Date.parse(date);

    return parsed;
  };

  checkStatus = (data) => {
    const { status } = this.props;
    const dateNow = Date.now();

    if (status && status.label === 'Live') {
      return (
        this.dateConvert(data.start_date) < dateNow &&
        (dateNow < this.dateConvert(data.end_date) || data.end_date === null)
      );
    }

    if (status && status.label === 'Ended') {
      return (dateNow > this.dateConvert(data.end_date) && data.end_date !== null);
    }

    return true;
  }

  render() {
    const {
      filter, performances
    } = this.props;

    return (
      <Row>
        <Col lg={12}>
          {(filter.label === 'Sell IT' || filter.label === 'All') &&
          (performances.sell_it && performances.sell_it.length > 0) && (
            performances.sell_it.map(data => (
              this.checkStatus(data) && (
                <SellIt key={data.id} data={data} label="Sell IT" />
              )
            ))
          )}
          {(filter.label === 'Blu Bar Sell It' || filter.label === 'All') &&
          (performances.ngp && performances.ngp.length > 0) && (
            performances.ngp.map(data => (
              this.checkStatus(data) && (
                <SellIt key={data.id} data={data} label="Blu Bar Sell It" />
              )
            ))
          )}
          {(filter.label === 'Price IT' || filter.label === 'All') &&
          (performances.price_it && performances.price_it.length > 0) && (
            performances.price_it.map(data => (
              this.checkStatus(data) && (
                <PriceIt key={data.id} data={data} />
              )
            ))
          )}
          {(filter.label === 'Stock IT' || filter.label === 'All') &&
          (performances.stock_it && performances.stock_it.length > 0) && (
            performances.stock_it.map(data => (
              this.checkStatus(data) && (
                <StockIt key={data.id} data={data} />
              )
            ))
          )}
          {(filter.label === 'Price IT +' || filter.label === 'All') &&
          (performances.price_it_plus && performances.price_it_plus.length > 0) && (
            performances.price_it_plus.map(data => (
              this.checkStatus(data) && (
                <PriceItPlus key={data.id} data={data} />
              )
            ))
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  performances: state.storePerformanceObjectives.data
});

export default connect(mapStateToProps)(UserPerformancesList);



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances-list.jsx